import PrivacyNoticePhoto from '../../assets/PrivacyNotice/PrivacyNotice.png';
import Footer from "../../components/Footer";
import {Helmet} from 'react-helmet';
import i18n from "../../i18n";
import './index.css';
import {useTranslation} from "react-i18next";
import {privacyContent} from './content';

const PrivacyNotice = () => {
    const {t} = useTranslation();
    const content = i18n.language === 'en' ? privacyContent.en : privacyContent.de;

    return (
        <>
            <div>
                <Helmet>
                    <html lang={i18n.language} />
                    <title>{t('PrivacyMetaTitle')}</title>
                    <link rel="canonical" href={`https://www.visoplan.de/${i18n.language}/privacy-notice`} />
                    <link rel="alternate" hreflang="en" href="https://www.visoplan.de/en/privacy-notice" />
                    <link rel="alternate" hreflang="de" href="https://www.visoplan.de/de/privacy-notice" />
                    <meta name="description" content={t('PrivacyMetaDescription')} />
                </Helmet>
                <div className={'PrivacyNoticeForehead'}>
                    <div className={'PrivacyNoticeForeheadData'}>
                        <h1>{t('PrivacyNotice')}</h1>
                        <p className={'subheading'}>{content.subtitle}</p>
                        <p className={'PrivacyNoticeParagraph'}>{content.scope}</p>
                        <a
                            className={'PrivacyNoticeLinkForehead'}
                            href={'#privacy-settings'}
                            onClick={(e) => {
                                e.preventDefault();
                                window.CookieConsent?.showPreferences?.();
                            }}
                        >{content.settings}</a>
                        <p className={'PrivacyNoticeParagraph'}>{content.asOf}</p>
                    </div>
                    <img src={PrivacyNoticePhoto} alt={''}/>
                </div>
                {content.sections.map((section) => (
                    <div key={section.title} className={'PrivacyNoticeBlockInfo'}>
                        <h4>{section.title}</h4>
                        {section.lines ? (
                            <div className={'PrivacyNoticeEmailInfo'}>
                                {section.lines.map((line) => <p key={line}>{line}</p>)}
                            </div>
                        ) : null}
                        {(section.paragraphs || []).map((paragraph) => (
                            <p key={paragraph} className={'PrivacyNoticeFormatedText'}>{paragraph}</p>
                        ))}
                    </div>
                ))}
                <Footer/>
            </div>
        </>
    )
}
export default PrivacyNotice;
